import { render, staticRenderFns } from "./LogMessageComponent.vue?vue&type=template&id=27c3a756"
import script from "./LogMessageComponent.vue?vue&type=script&lang=ts"
export * from "./LogMessageComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports